<template>
  <sword-popover-wuk>
    <ul class="flex gap-[0.15rem]">
      <li
        v-for="(_, index) of Array.from({length: levels.length})"
        :key="index"
        class="size-[0.6rem] rounded-[0.1875rem]"
        :class="[(selectedLevel && selectedLevel.size > index) ? selectedLevel.color : 'bg-gray-300']"
      ></li>
    </ul>
    <template #content>
      <div class="min-w-40 bg-white p-4">
        <h6 class="title t4 -mt_0 -mb_1">{{ $t("patients_funnel_mal") }}</h6>
        <sword-radio-group-wuk
          :checked="value || ''"
          :options="levels"
          fill-bg
          hide-errors
          variant="minimal"
          :style="{ '--wuk-radio-box-size-wuk': '1.4rem' }"
          @change="handleChangeLevel"
        />
      </div>
    </template>
  </sword-popover-wuk>
</template>

<script lang="ts" setup>
import { useAttrs, computed } from 'vue'
import { $http } from '@/plugins'

const props = withDefaults(defineProps<{
  disabled?: boolean,
  value?: string,
}>(), {
  disabled: false,
  value: '',
})

const emit = defineEmits<{
  (e: 'input', level: string): void
}>()

const levels = [
  {
    size: 3,
    optLabel: 'COMMON.HIGH',
    optValue: 'high',
    color: 'bg-negative-600',
  },
  {
    size: 2,
    optLabel: 'COMMON.LOW',
    optValue: 'low',
    color: 'bg-warning-600',
  },
  {
    size: 1,
    optLabel: 'COMMON.VERY_LOW',
    optValue: 'very_low',
    color: 'bg-positive-800',
  },
]

const selectedLevel = computed(() => levels.find((l) => l.optValue === props.value))

const attrs = useAttrs()

const handleChangeLevel = (level: string) => {
  const patientId = attrs['patient-id']
  const body = { attention_level: level, origin: 'clinical_portal' }

  $http('patient/profile/setAttentionLevel', patientId, { body })
  emit('input', level)
}
</script>
